import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
  border: '2px solid #0B57D0'
};

const DeleteModal = ({ open, closeModal, handleDeleteSelected }) => {
  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={modalStyle}>
        <Typography sx={{ fontSize: '16px', fontWeight: 'bold', pb: 1 }}>
          timetracker.com says
        </Typography>
        <Typography sx={{ fontSize: '16px', color: '#595959' }}>
          Are you sure you want to delete all activity in this time span (2:20 pm - 2:30 pm) for Amit Goyal?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mt: 2 }}>
          <Button sx={{ padding: '10px 15px', background: '#0B57D0', color: '#fff', borderRadius: '8px' }} onClick={() => { handleDeleteSelected(); closeModal(); }}>OK</Button>
          <Button sx={{ padding: '10px 15px', background: '#D9D9D9', color: '#373737', borderRadius: '8px' }} onClick={closeModal}>Cancel</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
